import React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

function IndependentRankings() {
    return (
        <>
            <Helmet>
                <title>Independent Rankings - Hockey Pipeline</title>
                <meta
                    name="description"
                    content="Independent NHL prospect rankings from Hockey Pipeline scouts, separate from publication mock drafts."
                />
                <link rel="canonical" href="https://hockeypipeline.com/independent-rankings" />
            </Helmet>
            <Container className="container top-container">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12}>
                        <Typography variant="h4" component="div" className="page-title">
                            Independent Rankings
                        </Typography>
                        <div className="title-underline" />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <Typography variant="body1" sx={{ color: 'var(--text-muted)', maxWidth: 720 }}>
                            Standalone scout rankings that are not tied to a specific publication mock draft.
                            Rankings content for this page will appear here as it is published.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export default IndependentRankings;
